import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import { namespaceGeneratedContent } from './namespace-generated-content.js'

export function namespaceGeneratedFiles(
  files: GeneratedFile[],
  namespace: string
): GeneratedFile[] {
  return files.map((file) => ({
    path: file.path,
    content: namespaceGeneratedContent(file.content, namespace, file.path)
  }))
}
